import { createActionGroup, emptyProps } from '@ngrx/store';

export const PageLoaderActions = createActionGroup({
  source: 'APP',
  events: {
    'Show page loader': emptyProps(),
    'Hide page loader': emptyProps(),
    'Hide page loader success': emptyProps(),
  },
});

export type PageLoaderActionUnion = ReturnType<typeof PageLoaderActions[keyof typeof PageLoaderActions]>;

export type ShowPageLoaderAction = ReturnType<typeof PageLoaderActions.showPageLoader>;
export type HidePageLoaderAction = ReturnType<typeof PageLoaderActions.hidePageLoader>;
export type HidePageLoaderSuccessAction = ReturnType<typeof PageLoaderActions.hidePageLoaderSuccess>;
